import styles from '../utility/utility.module.scss';
import {FlexRow} from '../utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {VehicleBrandModel} from './vehicle_brand_model.tsx';
import {Spacer} from '../utility/spacer.tsx';
import {Card} from '../card/card.tsx';
import {VehicleLogo, VehicleLogoSize} from './vehicle_logo.tsx';
import {CSSProperties} from 'react';

interface OwnProps {
    style?: CSSProperties;
}
export function VehiclePlaceholder({style}: OwnProps) {
    return (
        <Card style={style}>
            <VehicleLogo alt={'auto'} size={VehicleLogoSize.Large} />
            {/*BRAND MODEL*/}
            <FlexRow alignment={Alignment.Center}>
                <VehicleBrandModel brand={null} model={null} />
            </FlexRow>
            <Spacer style={{height: '1rem'}} />
            <FlexRow alignment={Alignment.Center}>
                <span className={styles.placeholder} style={{width: '30%'}} />
            </FlexRow>
        </Card>
    );
}
